<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2'
import moment from "moment";
import draggable from 'vuedraggable';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, draggable },
    data() {
        return {
            title: "Asociar evento",
            items: [
                {
                text: "Digitalizar",
                href: "/"
                },
                {
                text: "Asociar evento",
                active: true
                }
            ],
            usuarios:[],
            laborantes:[],
            eventos:[],
            lab:{},
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            asociaciones:[],
            ver:false,
            imagenesSeleccionadas: [],
            imagenesPreview: [],
            datosLabEvento:{},
            selected: '',
            isLoading: false,
            digitalizarDisabled: false,
        };
    },
    watch: {
        // imagenesPreview(newVal, oldVal) {
        //     // Solo reordena si la cantidad coincide
        //     if (newVal.length === this.imagenesSeleccionadas.length) {
        //         // Reordena imagenesSeleccionadas según el nuevo orden de preview usando el índice
        //         const nuevaSeleccion = [];
        //         newVal.forEach((preview, idx) => {
        //             // Busca el índice anterior del preview en oldVal
        //             const oldIndex = oldVal.indexOf(preview);
        //             if (oldIndex !== -1) {
        //                 nuevaSeleccion.push(this.imagenesSeleccionadas[oldIndex]);
        //             } else {
        //                 // Si no lo encuentra, conserva el anterior
        //                 nuevaSeleccion.push(this.imagenesSeleccionadas[idx]);
        //             }
        //         });
        //         this.imagenesSeleccionadas = nuevaSeleccion;
        //     }
        // }
    },
    computed:{
        rows() {
            return this.asociaciones.length;
        },
        filteredData() {
            return this.asociaciones.filter((item) => {
                const rut = item.rut ? item.rut.toLowerCase() : '';
                const name = item.name ? item.name.toLowerCase() : '';
                return (
                    rut.includes(this.filtro.toLowerCase()) ||
                    name.includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    methods:{
        asociar(){
            if (!this.lab.laborante || !this.lab.event) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Campos requeridos',
                    text: 'Debes seleccionar un laborante y un evento.'
                });
                return;
            }

            axios.post('/api/asociarLabEvento', {
                laborante_id: this.lab.laborante.id,
                laborante: this.lab.laborante,
                event_id: this.lab.event.id,
                event: this.lab.event
            })
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Asociación exitosa',
                    text: 'El laborante fue asociado al evento correctamente.'
                });
                this.ver = false;
                this.asociaciones=response.data.asociados;
                // Opcional: recargar asociaciones o limpiar selección
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo asociar el laborante al evento.'
                });
                console.error(error);
            });
        },
        labelselect_laborante ({ name }) {
            return `${name}`
        },
        labelEvento(evento) {
            return `${evento.codigo} - ${evento.nombre_difusion}`;
        },
        ver_boton(){
            if(this.ver){
                this.ver = false;
            }else{
                this.ver = true;
            }
        },
        cancelar(){
            if(!this.ver){
                this.ver = true;
            }else{
                this.ver = false;
            }
        },
        modal_subir_imagenes(item){
            console.log(item)
            this.datosLabEvento=item;
            this.$refs['modal-subir'].show();
        },
        agregarImagenes(event) {
            const nuevosArchivos = Array.from(event.target.files);
            nuevosArchivos.forEach((file) => {
                // Validar tipo de archivo
                const tiposPermitidos = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'application/pdf'];
                if (!tiposPermitidos.includes(file.type)) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Tipo de archivo no válido',
                        text: `El archivo ${file.name} no es una imagen o PDF válido.`
                    });
                    return;
                }

                const yaExiste = this.imagenesSeleccionadas.some(f => f.file.name === file.name && f.file.size === file.size);
                if (!yaExiste) {
                    if (file.type === 'application/pdf') {
                        // Para PDFs, usar un ícono genérico como preview
                        this.imagenesSeleccionadas.push({ 
                            file, 
                            preview: '/images/pdf-icon.png', // Necesitarás agregar este ícono
                            isPdf: true
                        });
                    } else {
                        // Para imágenes, crear preview normal
                        const lector = new FileReader();
                        lector.onload = (e) => {
                            this.imagenesSeleccionadas.push({ 
                                file, 
                                preview: e.target.result,
                                isPdf: false
                            });
                        };
                        lector.readAsDataURL(file);
                    }
                }
            });
            this.$refs.inputImagenes.value = '';
        },
        guardarImagenes() {
            this.isLoading = true;
            if (this.imagenesSeleccionadas.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Sin archivos',
                    text: 'Debes seleccionar al menos una imagen o PDF.'
                });
                this.isLoading = false;
                return;
            }
            const formData = new FormData();
            this.imagenesSeleccionadas.forEach((imgObj, i) => {
                formData.append(`imagenes[]`, imgObj.file);
            });
            formData.append('laborante_id', this.datosLabEvento.laborante_id);
            formData.append('evento_id', this.datosLabEvento.evento_id);
            axios.post('/api/uploadImagesS3', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: `${response.data.total_uploaded} archivo(s) procesado(s) correctamente`
                });
                this.imagenesSeleccionadas = [];
                this.$refs['modal-subir'].hide();
                this.isLoading = false;
                // Deshabilita el botón Digitalizar por 10 segundos
                this.digitalizarDisabled = true;
                axios.get('/api/get_asociados').then(response => {
                    if (this.user.rol=='Admin') {
                        this.asociaciones= response.data.asociados;
                    }else{
                        this.asociaciones= response.data.asociados.filter((us) => us.laborante.sede==this.user.sede);
                        console.log(this.asociaciones);
                    }
                });
                setTimeout(() => {
                    this.digitalizarDisabled = false;
                }, 10000);
            }).catch(error => {
                console.log(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un problema al procesar los archivos'
                });
                this.isLoading = false;
            });
        },
        eliminarImagen(index) {
            this.imagenesSeleccionadas.splice(index, 1);
            if (this.imagenesSeleccionadas.length === 0) {
                this.$refs.inputImagenes.reset();
            }
        },
        href_digitalizar(item){
            window.location.href = `/web/digitalizar/encuesta/${item.evento_id}/${item.laborante_id}`;
        },
        href_ver(item){
            window.location.href = `/web/digitalizar/ver/${item.evento_id}/${item.laborante_id}`;
        },
        formatFecha(fecha) {
            if (!fecha) return '-';
            // Si usas moment.js:
            return moment(fecha).format('DD/MM/YYYY');
            // Si no usas moment, puedes usar:
            // return new Date(fecha).toLocaleDateString();
        },
        progreso(item) {
            if (!item.total_imagenes || item.total_imagenes === 0) return 0;
            return Math.round((item.imagenes_digitalizadas / item.total_imagenes) * 100);
        }
    },
    mounted(){
        this.isLoading = true;
        axios.get('/api/get_laborantes').then(response => {
            if (this.user.rol=='Admin') {
                this.laborantes= response.data.usuarios;
            }else {
                this.laborantes= response.data.usuarios.filter((us) => us.sede==this.user.sede);
            }
        });
        axios.get('/api/get_eventos').then(response => {
            this.eventos= response.data.eventos;
            this.isLoading = false;
        });
        axios.get('/api/get_usuarios').then(response => {
            this.usuarios= response.data.usuarios;
        });
        axios.get('/api/get_asociados').then(response => {
            if (this.user.rol=='Admin') {
                this.asociaciones= response.data.asociados;
            }else if(this.user.rol=='Laborante'){
                this.asociaciones= response.data.asociados.filter((us) => us.laborante_id==this.user.id);
            }else{
                this.asociaciones= response.data.asociados.filter((us) => us.laborante.sede==this.user.sede);
                console.log(this.asociaciones);
            }
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card" v-if="user.rol!='Laborante'">
                    <div class="card-body">
                        <b-button variant="primary" @click="ver_boton" v-if="!ver">Agregar</b-button>
                        <div class="row" v-if="ver">
                            <div class="col-md-12">
                                <b-form-group label="Quien Asociar" v-slot="{ ariaDescribedby }">
                                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="Laborante">Laborante</b-form-radio>
                                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="Coordinador">Coordinador</b-form-radio>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row" v-if="selected==='Laborante'">
                                    <div class="col-md-6">
                                        <label for="pais"> Laborante:</label>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="lab.laborante"
                                            :options="laborantes" 
                                            placeholder="Seleccionar laborante" 
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_laborante"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="form-group row" v-else-if="selected==='Coordinador'">
                                    <div class="col-md-6">
                                        <label for="pais"> Coordinador:</label>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="lab.laborante"
                                            :options="usuarios" 
                                            placeholder="Seleccionar coordinador" 
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_laborante"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="selected!=''">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Evento:</label>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="lab.event"
                                            :options="eventos" 
                                            placeholder="Seleccionar evento" 
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelEvento"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-right">
                                <b-button variant="secondary" @click="cancelar">Cancelar</b-button>
                                <b-button variant="primary" @click="asociar">Asociar</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">Nº</th>
                                        <th style="width: 20%;">Nombre Laborante</th>
                                        <th style="width: 10%;">RUT</th>
                                        <th style="width: 10%;">Sede</th>
                                        <th style="width: 15%;">Evento</th>
                                        <th style="width: 15%;">Código Evento</th>
                                        <th style="width: 10%;">Cant. Fichas</th>
                                        <th style="width: 30%;">Avance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="item.id">
                                        <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                        <td>{{ item.laborante?.name || '-' }}</td>
                                        <td>{{ item.laborante?.rut || '-' }}</td>
                                        <td>{{ item.laborante?.sede || '-' }}</td>
                                        <td>{{ item.evento?.nombre_difusion || item.evento?.codigo || '-' }}</td>
                                        <td>{{ item.evento?.codigo || '-' }}</td>
                                        <td>{{ item.total_imagenes/2 || '-' }}</td>
                                        <td>
                                            <b-progress :value="progreso(item)" max="100" height="20px" show-progress animated>
                                                <b-progress-bar :value="progreso(item)" :variant="progreso(item) === 100 ? 'success' : 'warning'">
                                                {{ progreso(item) }}%
                                                </b-progress-bar>
                                            </b-progress>
                                        </td>
                                        <td>
                                            <div class="d-flex flex-row gap-2">
                                                <b-button class="m-1" size="sm" variant="primary" @click="modal_subir_imagenes(item)">
                                                    <i class="bx bx-image-add font-size-16"></i> Subir
                                                </b-button>
                                                <b-button
                                                    size="sm"
                                                    variant="primary"
                                                    @click="href_digitalizar(item)"
                                                    :disabled="digitalizarDisabled"
                                                >
                                                    <i class="bx bx-file-find font-size-16"></i> Digitalizar
                                                </b-button>
                                                <b-button class="m-1" size="sm" variant="primary" @click="href_ver(item)">
                                                    <i class="bx bx-show-alt font-size-16"></i> Ver
                                                </b-button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <b-modal ref="modal-subir" :title="'Subir imágenes o PDFs'" ok-title="Guardar" cancel-title="Cancelar" @ok="guardarImagenes">
                            <!-- Botón que activa el input -->
                            <b-button @click="$refs.inputImagenes.click()" variant="primary" class="mb-2">
                            Añadir imágenes o PDFs
                            </b-button>
                            <small class="text-muted d-block mb-2">
                                Formatos aceptados: JPG, PNG, GIF, PDF. Los PDFs se convertirán automáticamente en imágenes.
                            </small>
                            <!-- Input oculto -->
                            <input
                            type="file"
                            ref="inputImagenes"
                            multiple
                            accept="image/*,application/pdf"
                            @change="agregarImagenes"
                            style="display: none;"
                            />
                            <!-- Vista previa de imágenes -->
                            <!-- <div class="d-flex flex-wrap mt-3">
                                <div
                                    v-for="(img, index) in imagenesPreview"
                                    :key="index"
                                    class="position-relative m-2"
                                    style="width: 120px; height: 120px;"
                                >
                                    <img
                                    :src="img"
                                    alt="Imagen"
                                    class="img-thumbnail"
                                    style="width: 100%; height: 100%; object-fit: cover;"
                                    />
                                    <b-button
                                    size="sm"
                                    variant="danger"
                                    class="position-absolute"
                                    style="top: -10px; right: -10px; border-radius: 50%;"
                                    @click="eliminarImagen(index)"
                                    >
                                    ✕
                                    </b-button>
                                </div>
                            </div> -->
                            <draggable 
                                v-model="imagenesSeleccionadas" 
                                class="d-flex flex-wrap mt-3" 
                                :options="{ animation: 150 }"
                            >
                                <transition-group type="transition" name="fade" tag="div" class="d-flex flex-wrap">
                                    <div
                                        v-for="(imgObj, index) in imagenesSeleccionadas"
                                        :key="index*890"
                                        class="position-relative m-2"
                                        style="width: 120px; height: 120px; cursor: grab;"
                                    >
                                        <!-- Preview para imágenes -->
                                        <img
                                            v-if="!imgObj.isPdf"
                                            :src="imgObj.preview"
                                            alt="Imagen"
                                            class="img-thumbnail"
                                            style="width: 100%; height: 100%; object-fit: cover;"
                                        />
                                        <!-- Preview para PDFs -->
                                        <div
                                            v-else
                                            class="d-flex flex-column align-items-center justify-content-center img-thumbnail"
                                            style="width: 100%; height: 100%; background-color: #f8f9fa;"
                                        >
                                            <i class="bx bxs-file-pdf" style="font-size: 32px; color: #dc3545;"></i>
                                            <small class="text-muted text-center mt-1" style="font-size: 10px;">
                                                {{ imgObj.file.name.length > 15 ? imgObj.file.name.substring(0, 12) + '...' : imgObj.file.name }}
                                            </small>
                                        </div>
                                        <b-button
                                            size="sm"
                                            variant="danger"
                                            class="position-absolute"
                                            style="top: -10px; right: -10px; border-radius: 50%;"
                                            @click="eliminarImagen(index)"
                                        >
                                            ✕
                                        </b-button>
                                    </div>
                                </transition-group>
                            </draggable>

                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>